import React from "react";
import { Button, Form } from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { SelectWithSearch } from "@comps/components";

const PolicySelectWithActions = (props) => {
  return (
    <Form.Item label={ props.label } className="da-mb-10">
      <div style={ { display: "flex", gap: 8, alignItems: "center" } }>
        <div style={ { flex: 1 } }>
          <Form.Item name={ props.name } rules={ props.rules } noStyle>
            <SelectWithSearch
              placeholder={ props.placeholder }
              options={ props.options }
            />
          </Form.Item>
        </div>
        <Button
          type="default"
          icon={ <PlusOutlined /> }
          onClick={ props.onCreate }
          title={ `Create ${props.buttonLabel}` }
        />
        <Button
          type="default"
          icon={ <EditOutlined /> }
          onClick={ props.onEdit }
          disabled={ !props.selectedValue }
          title={ props.selectedValue ? `Edit ${props.buttonLabel}` : `Select ${props.buttonLabel} first` }
        />
        <Button
          type="default"
          danger
          icon={ <DeleteOutlined /> }
          onClick={ props.onDelete }
          disabled={ !props.selectedValue }
          title={ props.selectedValue ? `Remove ${props.buttonLabel} from this planner` : `Select ${props.buttonLabel} first` }
        />
      </div>
    </Form.Item>
  );
};

export default PolicySelectWithActions;
